import React from 'react';
import MobileApp from 'components/Tvendo/Setting/MobileApp/List.js';

export default function () {
  return <MobileApp />;
}
